import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';
import PurchaseModel from '../model/PurchaseModel.js';
import CampaignModel from '@/core/Campaign/model/CampaignModel.js';

/**
 * @method apiGetPurchase
 * @method apiRedeem
 * @method apiRedeemUse
 */
export default {
    config: function () {
        return Vue.bzbsConfig;
    },
    /**
     * @param {String} bzbsToken
     * @param {Object} listConfig PurchaseListConfigModel - /service/config/HistoryConfigModel.js
     * @param {Object} filterListConfig PurchaseFilterConfigModel - /service/config/HistoryConfigModel.js
     */
    apiGetPurchase: function (bzbsToken, params) {
        var url = this.config().bzbsUrl + '/redeem';
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, bzbsToken, params).then((response) => {
                var purchases = [];
                for (var item of response.data) {
                    var purchase = new PurchaseModel (item);
                    purchases.push(purchase);
                }

                resolve(purchases);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    /**
     * @param {String} token
     * @param {String} redeemKey
     */
    apiRedeem: function (token, redeemKey) {
        var params = {};

        var url = this.config().bzbsUrl + '/redeem/' + redeemKey;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, token, params).then((response) => {
                var result = new CampaignModel(response.data);
                resolve(result);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    /**
     * @param {String} token
     * @param {String} redeemKey
     */
    apiRedeemUse: function (token, redeemKey) {
        var params = {};

        var url = this.config().bzbsUrl + '/redeem/' + redeemKey + '/use';
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(url, token, params).then((response) => {
                var result = new CampaignModel(response.data);
                resolve(result);
            }).catch((error) => {
                reject(error);
            });
        });
    }
}
